import { createContext } from "react";
import {
  Periodo,
  Medidas,
  Variables,
  Entorno,
  Canal,
  Detalle,
} from "./utils/constants";
import { Fill, Font } from "exceljs";

const currentYear = new Date().getFullYear();

export const defaults: { weeks: IWeeks; filters: IFilter } = {
  weeks: [
    { year: currentYear, week: 1 },
    { year: currentYear, week: 1 },
  ],
  filters: {
    periodo: Periodo.Semana,
    medidas: Medidas.Ventas,
    variables: Variables.Total,
    entorno: Entorno.Total,
    misdatos: 0,
    detalle: Detalle.Desglose,
    segmentos: [],
    especialidades: [],
    mustSelectChain: false,
    segmentType: 0,
    segment: 0,
    lever: 0,
    leverType: 0,
    channel: 0,
    moment: 0,
    region: 0,
    location: 0,
  },
};

export type IFilters = {
  limitedPeriodo: boolean;
  showMedidas: boolean;
  hasTicketMedio: boolean;
  isDesglose: boolean;
  showEntorno: boolean;
  showSegmentos: boolean;
  showMyData?: boolean;
  onlyYears?: boolean;
  showCanal?: boolean;
  mustSelectChain?: boolean;
  showVariable?: boolean;
};

export type IExcelColor = {
  main: {
    bg: Fill;
    font: Partial<Font>;
  };
  title: {
    bg: Fill;
    font: Partial<Font>;
  };
};

export interface IUsuario {
  Internal?: string;
  Error?: string;
  UUID: string;
  Nombre: string;
  Email: string;
  Pass: string;
  Compania: ICompania;
  Cadena: ICadena;
  Rol: IRolUsuario;
  hasVentas: boolean;
  Ventas: IVenta[];
}

export interface IRolUsuario {
  Internal?: string;
  Error?: string;
  UUID: string;
  Descripcion: string;
  canRead: boolean;
  canWrite: boolean;
  canDownload: boolean;
  isAdmin: boolean;
  Usuarios: IUsuario[];
}

export interface ICompania {
  Internal?: string;
  Error?: string;
  UUID: string;
  Nombre: string;
  hasCadenas: boolean;
  Cadenas: ICadena[];
  hasUsuarios: boolean;
  Usuarios: IUsuario[];
}

export interface ICadena {
  Internal?: string;
  Error?: string;
  UUID: string;
  Nombre: string;
  Compania: ICompania;
  Segmento: ISegmento[];
  Especialidad: IEspecialidad[];
  Contacto?: IContacto;
  CargaIVA?: boolean;
  Ratio: number;
  hasUsuarios: boolean;
  Usuarios: IUsuario[];
  hasVentas: boolean;
  Ventas: IVenta[];
}

export interface ISegmento {
  Internal?: string;
  Error?: string;
  UUID: string;
  Descripcion: string;
  hasCadenas: boolean;
  Cadenas: ICadena[];
}

export interface IEspecialidad {
  Internal?: string;
  Error?: string;
  UUID?: string;
  Descripcion?: string;
  hasCadenas: boolean;
  Cadenas: ICadena[];
}

export interface IContacto {
  Error?: string;
  Nombre?: string;
  Email?: string;
  Telefono?: string;
}

export interface IEvento {
  Error?: string;
  Semana: number;
  Anyo: number;
  UUID: string;
  Evento: string;
  Comentario: string;
}

interface IDesglose {
  Totales: number;
  Canal: {
    Delivery: number;
    TakeAway: number;
    Local: number;
  };
  Ubicacion: {
    Calle: number;
    CC: number;
    Concesiones: number;
    Otros: number;
  };
  Region: {
    Z1: number;
    Z2: number;
    Z3: number;
    Z4: number;
    Z5: number;
    Z6: number;
  };
  Momento: {
    T1: number;
    T2: number;
    T3: number;
    T4: number;
    T5: number;
    T6: number;
  };
}

interface ILocalesRegion {
  Z1: number;
  Z2: number;
  Z3: number;
  Z4: number;
  Z5: number;
  Z6: number;
}

interface IVentasAgregadores {
  Ventas: number;
  VentasAP: number;
  Tickets: number;
  TicketsAP: number;
}

interface IVentasPropios {
  Ventas: number;
  VentasAP: number;
  Tickets: number;
  TicketsAP: number;
}

interface IVentasTurismo {
  Ventas: number;
  VentasAP: number;
  Tickets: number;
  TicketsAP: number;
}

export interface IVenta {
  Internal?: string;
  Error?: string;
  UUID: string;
  Usuario: IUsuario;
  Semana: number;
  Anyo: number;
  LastYear?: {
    // Totales originales
    VentasComparables: number;
    TicketsComparables: number;
    LocalesComparables: number;
    LocalesRepComparables: number;
    // Totales 
    VentasComp_CurrentYear?: number;
    VentasComp_Last?: number;
    TicketsComp_CurrentYear?: number;
    TicketsComp_Last?: number;
    LocalesComp_CurrentYear?: number;
    LocalesComp_Last?: number;
    LocalesRepComp_CurrentYear?: number;
    LocalesRepComp_Last?: number;
    // Canal ventas
    Del_VentasComp_CurrentYear?: number;
    Del_VentasComp_Last?: number;
    Taw_VentasComp_CurrentYear?: number;
    Taw_VentasComp_Last?: number;
    Local_VentasComp_CurrentYear?: number;
    Local_VentasComp_Last?: number;
    // Canal tickets
    Del_TicketsComp_CurrentYear?: number;
    Del_TicketsComp_Last?: number;
    Taw_TicketsComp_CurrentYear?: number;
    Taw_TicketsComp_Last?: number;
    Local_TicketsComp_CurrentYear?: number;
    Local_TicketsComp_Last?: number;
    // Ubicacion ventas
    Calle_VentasComp_CurrentYear?: number;
    Calle_VentasComp_Last?: number;
    CC_VentasComp_CurrentYear?: number;
    CC_VentasComp_Last?: number;
    Conces_VentasComp_CurrentYear?: number;
    Conces_VentasComp_Last?: number;
    Otros_VentasComp_CurrentYear?: number;
    Otros_VentasComp_Last?: number;
    // Ubicacion tickets
    Calle_TicketsComp_CurrentYear?: number;
    Calle_TicketsComp_Last?: number;
    CC_TicketsComp_CurrentYear?: number;
    CC_TicketsComp_Last?: number;
    Conces_TicketsComp_CurrentYear?: number;
    Conces_TicketsComp_Last?: number;
    Otros_TicketsComp_CurrentYear?: number;
    Otros_TicketsComp_Last?: number;
    // Region ventas
    Z1_VentasComp_CurrentYear?: number;
    Z1_VentasComp_Last?: number;
    Z2_VentasComp_CurrentYear?: number;
    Z2_VentasComp_Last?: number;
    Z3_VentasComp_CurrentYear?: number;
    Z3_VentasComp_Last?: number;
    Z4_VentasComp_CurrentYear?: number;
    Z4_VentasComp_Last?: number;
    Z5_VentasComp_CurrentYear?: number;
    Z5_VentasComp_Last?: number;
    Z6_VentasComp_CurrentYear?: number;
    Z6_VentasComp_Last?: number;
    // Region tickets
    Z1_TicketsComp_CurrentYear?: number;
    Z1_TicketsComp_Last?: number;
    Z2_TicketsComp_CurrentYear?: number;
    Z2_TicketsComp_Last?: number;
    Z3_TicketsComp_CurrentYear?: number;
    Z3_TicketsComp_Last?: number;
    Z4_TicketsComp_CurrentYear?: number;
    Z4_TicketsComp_Last?: number;
    Z5_TicketsComp_CurrentYear?: number;
    Z5_TicketsComp_Last?: number;
    Z6_TicketsComp_CurrentYear?: number;
    Z6_TicketsComp_Last?: number;
    // Momento ventas
    T1_VentasComp_CurrentYear?: number;
    T1_VentasComp_Last?: number;
    T2_VentasComp_CurrentYear?: number;
    T2_VentasComp_Last?: number;
    T3_VentasComp_CurrentYear?: number;
    T3_VentasComp_Last?: number;
    T4_VentasComp_CurrentYear?: number;
    T4_VentasComp_Last?: number;
    T5_VentasComp_CurrentYear?: number;
    T5_VentasComp_Last?: number;
    T6_VentasComp_CurrentYear?: number;
    T6_VentasComp_Last?: number;
    // Momento tickets
    T1_TicketsComp_CurrentYear?: number;
    T1_TicketsComp_Last?: number;
    T2_TicketsComp_CurrentYear?: number;
    T2_TicketsComp_Last?: number;
    T3_TicketsComp_CurrentYear?: number;
    T3_TicketsComp_Last?: number;
    T4_TicketsComp_CurrentYear?: number;
    T4_TicketsComp_Last?: number;
    T5_TicketsComp_CurrentYear?: number;
    T5_TicketsComp_Last?: number;
    T6_TicketsComp_CurrentYear?: number;
    T6_TicketsComp_Last?: number;
  };
  Actual: {
    Ventas: {
      Bruto: IDesglose;
      Comparable: IDesglose;
    };
    Tickets: {
      Bruto: IDesglose;
      Comparable: IDesglose;
    };
    Locales: {
      Aperturas: number;
      Cierres: number;
      Bruto: {
        Total: number;
        Reportan: number;
        Self: number;
        Delivery: number;
        Region: ILocalesRegion;
      };
      Comparable: {
        Total: number;
        Reportan: number;
      };
    };
    Agregadores: IVentasAgregadores;
    Propios: IVentasPropios;
    Turismo: IVentasTurismo;
  };
  Anterior: {
    Ventas: {
      Bruto: IDesglose;
      Comparable: IDesglose;
    };
    Tickets: {
      Bruto: IDesglose;
      Comparable: IDesglose;
    };
    Locales: {
      Aperturas: number;
      Cierres: number;
      Bruto: {
        Total: number;
        Reportan: number;
        Self: number;
        Delivery: number;
        Region: ILocalesRegion;
      };
      Comparable: {
        Total: number;
        Reportan: number;
      };
    };
    Agregadores: IVentasAgregadores;
    Propios: IVentasPropios;
    Turismo: IVentasTurismo;
  };
  Modelizacion: number;
  Ratio: number;
  Cadena: ICadena;
}

export type IWeek = { year: number; week: number };
export type IWeeks = IWeek[];
export type IFilter = {
  periodo: number;
  medidas: number;
  variables: number;
  entorno: number;
  misdatos: number;
  detalle?: number;
  segmentos: string[];
  especialidades: string[];
  palanca?: number;
  mustSelectChain?: boolean;
  segmentType: number;
  segment: number;
  leverType: number;
  lever: number;
  channel?: number;
  moment?: number;
  region?: number;
  location?: number;
  cadena?: string;
};

export type IContextProps = {
  semanas: IWeeks;
  setSemanas: Function;
  filters: IFilter;
  setFilters: Function;
  section: number;
  setSection: Function;
  sectionItem: 0;
  setSectionItem: Function;
  semanasDatos: IWeeks;
  cadenas: string[];
  user: string;
  userName: string;
  isAdmin?: boolean;
};

const AppContext = createContext<IContextProps>({
  semanas: defaults.weeks,
  setSemanas: Function,
  filters: defaults.filters,
  setFilters: Function,
  section: 0,
  setSection: Function,
  sectionItem: 0,
  setSectionItem: Function,
  semanasDatos: defaults.weeks,
  cadenas: [],
  user: "",
  userName: "",
});

export { AppContext as default };